module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Professional Association Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_vm._l((_vm.CheckboxBusiness), function(value, key) {
    return (_vm.FormInputs.BusinessOrganization) ? _c('div', {
      staticClass: "form-check"
    }, [(_vm.AccountEdit.organizations) ? _c('span', {
      staticClass: "form-check-label account_p"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.AccountEdit.organizations.list),
        expression: "AccountEdit.organizations.list"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.AccountEdit.organizations.list) ? _vm._i(_vm.AccountEdit.organizations.list, key) > -1 : (_vm.AccountEdit.organizations.list)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.AccountEdit.organizations.list,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.AccountEdit.organizations, "list", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.AccountEdit.organizations, "list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.AccountEdit.organizations, "list", $$c)
          }
        }
      }
    }), _vm._v("\n                  " + _vm._s(key) + "\n              ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.AccountEdit.organizations.list.indexOf('Other') >= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "account_p"
  }, [_vm._v("Please enter any other professional organizations you are associated with separated by semicolon(;).")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.organizations.others),
      expression: "AccountEdit.organizations.others"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.organizations.others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.organizations, "others", $event.target.value)
      }
    }
  })]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Professional Associations")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2bcea95e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bcea95e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/userAccount/accountEdit/EditAssociationInfo.vue
// module id = 481
// module chunks = 3